const form = document.querySelector('#lexique-search');
const input = document.querySelector('input[name="lexique-search"]');
const wrapper_list = document.querySelector('.lexique_list');
const inner_list = wrapper_list.innerHTML;
const wordsJSON = words.JSON;

let delay;

function autocomplete(event) {
    const input_value      = event.target.value.toLowerCase();
    const min_input_length = (input_value.length > 2);

    // Si - de 3 caractères on remet la liste de base
    if(!min_input_length) {
        wrapper_list.innerHTML = inner_list;
        return;
    }

    const filtered_list = wordsJSON.filter(word => word.title.toLowerCase().includes(input_value))
    let html = '<li>Aucun mot trouvé</li>';

    if(filtered_list.length) html = filtered_list.map(word => `<li class="word"><a href="${word.url}" class="link">${word.title}</a></li>`)
    wrapper_list.innerHTML = typeof html === 'object' ? html.join("") : html;
}

form.addEventListener('submit', (e) => {
    e.preventDefault();
})

input.addEventListener('input', (e) => {
    if(delay) clearInterval(delay);
    delay = setTimeout(() => autocomplete(e), 500);
})

